import { render, staticRenderFns } from "./dollars-detail.vue?vue&type=template&id=8860dece&scoped=true"
import script from "./dollars-detail.vue?vue&type=script&lang=js"
export * from "./dollars-detail.vue?vue&type=script&lang=js"
import style0 from "./dollars-detail.vue?vue&type=style&index=0&id=8860dece&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8860dece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8860dece')) {
      api.createRecord('8860dece', component.options)
    } else {
      api.reload('8860dece', component.options)
    }
    module.hot.accept("./dollars-detail.vue?vue&type=template&id=8860dece&scoped=true", function () {
      api.rerender('8860dece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dollars/dollars-detail.vue"
export default component.exports